/* UPP redesign: estimated delivery range (made to order, in stock, expedite, white glove).
   Fills every [data-upp-eta] with "Mon D – Mon D" from today's date.
   - data-prep-min/max/unit + data-tr-min/max/unit (snippets/upp-delivery-estimate with a variant):
     today + prep, then + transit; units d = calendar days, bd = business days (Mon–Fri), w = weeks.
   - otherwise (no variant): today + data-build-min/max weeks (or data-build-*-days), then
     data-ship-min/max business days. */
(function () {
  if (window.uppEta) return;
  function addBusinessDays(d, n) {
    var out = new Date(d.getTime());
    while (n > 0) {
      out.setDate(out.getDate() + 1);
      var day = out.getDay();
      if (day !== 0 && day !== 6) n--;
    }
    return out;
  }
  function add(d, n, unit) {
    if (unit === 'bd') return addBusinessDays(d, n);
    var out = new Date(d.getTime());
    out.setDate(out.getDate() + n * (unit === 'w' ? 7 : 1));
    return out;
  }
  function fmt(d) {
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }
  function range(el) {
    var n = function (k, f) { var v = parseInt(el.getAttribute('data-' + k), 10); return isNaN(v) ? f : v; };
    var today = new Date();
    today.setHours(12, 0, 0, 0);
    var pu = el.getAttribute('data-prep-unit');
    if (pu) {
      var tu = el.getAttribute('data-tr-unit') || 'bd';
      var from = add(add(today, n('prep-min', 0), pu), n('tr-min', 0), tu);
      var to = add(add(today, n('prep-max', 0), pu), n('tr-max', 0), tu);
      return fmt(from) + ' – ' + fmt(to);
    }
    var a = new Date(today.getTime()); a.setDate(a.getDate() + n('build-min-days', n('build-min', 6) * 7));
    var b = new Date(today.getTime()); b.setDate(b.getDate() + n('build-max-days', n('build-max', 7) * 7));
    return fmt(addBusinessDays(a, n('ship-min', 3))) + ' – ' + fmt(addBusinessDays(b, n('ship-max', 5)));
  }
  window.uppEta = function (root) {
    (root || document).querySelectorAll('[data-upp-eta]').forEach(function (el) { el.textContent = range(el); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { window.uppEta(); });
  else window.uppEta();
})();
